import { ActivatedRouteSnapshot, Route } from '@angular/router';
import { inject } from '@angular/core';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { UserService } from './service/user.service';
import { ImportUsersComponent } from './components/import-users/import-users.component';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { AuthGuard } from './service/auth.guard';
import { PERMISSION } from '@clearing-hub/common';
import { AuthenticationService } from './service/authentication.service';

export const canActivate = (route, guard = inject(AuthGuard)) => guard.canActivate(route);

export const appRoutes: Route[] = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: 'user-management',
        component: UserManagementComponent,
        data: {
          permission: PERMISSION.USER_MANAGEMENT_LIST_USERS
        },
        resolve: {
          preload: () => inject(UserService).preload(),
          userPoolInfo: () => inject(AuthenticationService).getUserPoolInfo()
        },
        canActivate: [(route: ActivatedRouteSnapshot) => canActivate(route)]
      },
      {
        path: 'import-users',
        component: ImportUsersComponent,
        data: {
          permission: PERMISSION.USER_MANAGEMENT_IMPORT_USER
        },
        resolve: {
          preload: () => inject(UserService).getUserPools()
        },
        canActivate: [(route: ActivatedRouteSnapshot) => canActivate(route)]
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'user-management'
      }
    ],
  },
  {
    path: '**',
    redirectTo: 'user-management'
  }
];
